/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useState, useEffect } from 'react';
// reactstrap components
import {
  Card,
  CardHeader,
  Container,
  Row,
  Button,
  Modal,
  Col,
  FormGroup,
  InputGroup,
  Table,
} from 'reactstrap';
// core components

import Header from 'components/Headers/Header.js';
import api from 'services/api';
import Log from 'models/Log';
import { useHistory, useLocation } from 'react-router-dom';
import { FaArrowLeft, FaDownload } from 'react-icons/fa';
import Orcamento from 'models/Orcamento';
import { downloadFileFromUrl } from 'utils/download';
import { TableBody, TableHead } from '@material-ui/core';

interface LocationState {
  nomeChave: string;
  valorChave: number | string;
  modalState: boolean;
  tipo?: string[];
  titulo?: string;
  orcamento: Orcamento;
}

export default function InterfaceLogs(): JSX.Element {
  const location = useLocation<LocationState>();
  const history = useHistory();
  const { nomeChave, valorChave, tipo, orcamento } = location.state;
  const [dados, setDados] = useState([] as any[]);
  const [notificationModalState, setNotificationModalState] = useState(false);

  async function listalogs() {
    const response = await api.get('/log', {
      params: {
        nomeChave,
        valorChave,
        tipo,
      },
    });

    const log: Log[] = response.data;

    setDados(log);
  }

  useEffect(() => {
    listalogs();
  }, []);

  return (
    <>
      <Header showCards={false} />
      {/* Page content */}
      <Container className="mt--7" fluid>
        <Row>
          <Col sm="10">
            <FormGroup className="mb-4">
              <InputGroup className="input-group-alternative">
                <Button
                  className="btn-icon btn-2"
                  color="primary"
                  type="button"
                  onClick={() => {
                    // eslint-disable-next-line no-restricted-globals
                    history.push({
                      pathname: `/admin/cadastro-orcamento-novo`,
                      state: { orcamento },
                    });
                  }}
                >
                  <FaArrowLeft />
                  <span className="btn-inner--text">Voltar</span>
                </Button>
              </InputGroup>
            </FormGroup>
          </Col>
        </Row>
        {/* Table */}
        <Row>
          <div className="col">
            <Modal
              className="modal-dialog-centered modal-danger"
              contentClassName="bg-gradient-danger"
              isOpen={notificationModalState}
              toggle={() => setNotificationModalState(!notificationModalState)}
            >
              <div className="modal-header">
                <h6 className="modal-title" id="modal-title-notification">
                  {/* Your attention is required */}
                </h6>
                <button
                  aria-label="Close"
                  className="close"
                  data-dismiss="modal"
                  type="button"
                  onClick={() =>
                    setNotificationModalState(!notificationModalState)
                  }
                >
                  <span aria-hidden>×</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="py-3 text-center">
                  <i className="ni ni-bell-55 ni-3x" />
                  <h4 className="heading mt-4">
                    Não é possível criar novo registro
                  </h4>
                  <p>
                    Já existe um registro com esse modelo e lance selecionado
                  </p>
                </div>
              </div>
              <div className="modal-footer">
                {/* <Button className="btn-white" color="default" type="button">
                  Entendi
                </Button> */}
                <Button
                  className="text-white ml-auto"
                  color="link"
                  data-dismiss="modal"
                  type="button"
                  onClick={() =>
                    setNotificationModalState(!notificationModalState)
                  }
                >
                  Fechar
                </Button>
              </div>
            </Modal>

            <Card className="shadow">
              <CardHeader className="border-0">
                <h3 className="mb-0">Logs da configuração #{orcamento.id}</h3>
              </CardHeader>
              <div style={{ minHeight: 700, width: '100%' }}>
                <Table className="full-table" responsive>
                  <TableHead>
                    <tr>
                      <th>#</th>
                      <th>Descrição</th>
                      <th>Data</th>
                      <th>Usuário</th>
                      <th />
                    </tr>
                  </TableHead>
                  <TableBody>
                    {dados?.map((item: Log) => {
                      return (
                        <tr>
                          <td>{item.id}</td>
                          <td>{item.descricao}</td>
                          <td>
                            {String(
                              new Intl.DateTimeFormat('pt-BR', {
                                dateStyle: 'short',
                                timeStyle: 'medium',
                              }).format(new Date(item.dataGeracao)),
                            )}
                          </td>
                          <td>{item.usuario?.nome}</td>
                          <td>
                            <div hidden={!item.arquivo}>
                              <Button
                                color="primary"
                                type="button"
                                size="sm"
                                className="float-right"
                                outline
                                title="Baixar arquivo"
                                onClick={() => {
                                  if (item.arquivo)
                                    downloadFileFromUrl(
                                      item.arquivo.url,
                                      item.arquivo.nome,
                                    );
                                }}
                              >
                                <FaDownload />
                              </Button>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </TableBody>
                </Table>

                {/* CustomTable */}
                {/* <CustomTable
                  enableSearchField
                  rows={logs}
                  header={header}
                  onDelete={undefined}
                  ocultaBotoes
                /> */}
                {/* END CustomTable */}
              </div>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
}
